export const actions = {
  set: 'SET_CHANNELS',
  add: 'ADD_CHANNELS',
  reset: 'RESET_CHANNELS',
};

/**
 * Set channels
 * @param  {Object[]} channels    Array of channels data
 * @return {Object}               Action to set channels
 */
export const setChannels = channels => ({
  type: actions.set,
  channels: channels,
});

export const resetChannels = () => ({
  type: actions.reset,
});

export const addChannels = channels => ({
  type: actions.add,
  channels: channels,
});
